
export const CartEvents = {
    ITEM_SAVED: 'item-saved',
    ITEM_REMOVED: 'remove-from-cart',
    ADD_ALL_TO_CART: 'add-all-to-cart',
    CART_UPDATE: 'cart-update'
};
